import React from "react";

const SidebarSkeleton = () => {
  return (
    <div className="flex w-full flex-col items-start gap-1">
      {[1, 2, 3, 4, 5].map((item) => (
        <div
          key={`sidebar-skeleton-${item}`}
          className="flex w-full items-center gap-3 px-4 py-2"
        >
          <div className="h-4 w-4 bg-gray-200 rounded animate-pulse"></div>
          <div className="h-4 w-24 bg-gray-200 rounded animate-pulse"></div>
        </div>
      ))}
    </div>
  );
};

export default SidebarSkeleton; 